import PortalLayout from '../PortalLayout';
import { EmployerProvider, useEmployer } from './context/EmployerContext';
import { NAV } from './nav';
import { useAuth } from '../../auth/AuthContext';
import { userLabel, userInitials } from '../../auth/roles';

/* Employer admin portal shell. Scoped to the employer_admin's own
   employer group(s) — see EMP-01 through EMP-04 in BrandonUserStoryAPI.md.
   RequireRole (see src/App.js) already guarantees `user` is set and
   role === 'employer_admin' by the time this renders.

   Unlike ICIB admin's scope selector (icib-admin/DashboardLayout.js),
   there's no "All groups" option here — every EMP-0x endpoint needs one
   concrete company_id, and an employer_admin has no `GET /companies` to browse
   anyway (icib_admin-only, README §4.3) — see EmployerContext's module
   comment for how the option list below is resolved instead. */
function EmployerLayoutInner() {
  const { db, groupId, setGroupId, curGroup, refreshing } = useEmployer();
  const { user } = useAuth();

  return (
    <PortalLayout
      navSections={NAV}
      brandRole="Employer console"
      userLabel={userLabel(user, 'Employer Admin')}
      userInitials={userInitials(user)}
      loading={refreshing}
      groupScope={{
        value: groupId ?? '',
        onChange: (v) => setGroupId(v || null),
        tag: curGroup()?.company_code,
        disabled: db.groups.length === 0,
        options: db.groups.length
          ? db.groups.map((g) => ({ id: g.id, label: `${g.name} · ${g.company_code}` }))
          : [{ id: '', label: 'No company assigned' }],
      }}
    />
  );
}

function EmployerLayout() {
  return (
    <EmployerProvider>
      <EmployerLayoutInner />
    </EmployerProvider>
  );
}

export default EmployerLayout;
